module.exports = __webpack_public_path__ + "static/media/390-Toledo.bad2cc2b.jpg";